type TFilters = {
  latestFundingRound?: string[];
  locations?: string[];
  tags?: string[];
  staticTags?: string[];
  name?: string;
  fundingMin?: number;
  fundingMax?: number;
};

export function createCommonFilter(filters: TFilters) {
  const commonFilter: any = {};
  let filterAdded = false;

  if (filters.latestFundingRound && filters.latestFundingRound.length > 0) {
    commonFilter.financialStages = filters.latestFundingRound;
    filterAdded = true;
  }

  if (filters.locations && filters.locations.length > 0) {
    commonFilter.regions = filters.locations;
    filterAdded = true;
  }

  if (filters?.tags && filters?.tags?.length > 0) {
    commonFilter.tagNames = filters.tags;
    filterAdded = true;
  }

  if (filters?.staticTags && filters?.staticTags?.length > 0) {
    commonFilter.staticTags = filters.staticTags;
    filterAdded = true;
  }

  if (filters?.name && filters?.name?.length > 0) {
    commonFilter.query = filters.name;
    filterAdded = true;
  }

  if (filters?.fundingMin || filters?.fundingMax) {
    commonFilter.funding =
      !filters?.fundingMin && !filters?.fundingMax
        ? undefined
        : [filters?.fundingMin || 0, filters?.fundingMax || Number.MAX_SAFE_INTEGER];

    filterAdded = true;
  }

  return { commonFilter, filterAdded };
}
